import get from 'lodash/get';
import { api } from '$app/api';
import { NULLABLE_STRING_FIELDS } from '../../utils/normalizeOptionalStrings';

const valueExists = (val) => val !== undefined && val !== null;

/** Response-only fields. The API computes these; they must not be written back. */
const RESPONSE_ONLY_FIELDS = ['sync'];

const cleanGarageData = (garage) =>
  Object.keys(garage).reduce((acc, i) => {
    if (RESPONSE_ONLY_FIELDS.includes(i)) return acc;
    // Keep explicit null for nullable fields so clearing them persists to the API.
    if (NULLABLE_STRING_FIELDS.includes(i)) {
      if (garage[i] !== undefined) acc[i] = garage[i];
      return acc;
    }
    if (valueExists(garage[i])) acc[i] = garage[i];
    return acc;
  }, {});

export function getTerritories() {
  return api
    .get(`/zones/territories`)
    .then((res) => res.data)
    .then((territories) =>
      territories.sort((a, b) => (a.territoryName || '')?.localeCompare(b.territoryName))
    );
}

export function getGarageById(garageId) {
  return api
    .get(`/garages/${garageId}`)
    .then((res) => res.data)
    .then((garage) => {
      garage.garageDeliveryOption = get(garage, 'deliveryOptions[0].deliveryOption');
      return garage;
    });
}

export function getGarageGaryAuthLink(garageId) {
  return api
    .get(`/garages/${garageId}/authLink`, { params: { page: 'garage' } })
    .then((res) => res.data.autoLoginLink);
}

export function getGarageDetailsById(garageId) {
  return api
    .get(`/garages/${garageId}/details`)
    .then((res) => res.data)
    .then((garage) => {
      garage.garageDeliveryOption = get(garage, 'deliveryOptions[0].deliveryOption');
      return garage;
    });
}

export function addGarageDetailsById(garageId, data) {
  return api.post(`/garages/${garageId}/details`, data).then((res) => res.data);
}

export function updateGarageDetailsById(garageId, data) {
  return api.patch(`/garages/${garageId}/details`, data).then((res) => res.data);
}

export function deleteGarageDetail(garageId, data) {
  return api.patch(`/garages/${garageId}/details`, { ...data, status: 'deleted' }).then((res) => res.data);
}

export function addGarageDetailsImageById(garageId, data) {
  return api.post(`/garages/${garageId}/details/image`, data).then((res) => res.data);
}

export function putGarageById(garageId, data) {
  return api
    .put(`/garages/${garageId}`, cleanGarageData(data))
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export function createGarage(data) {
  return api.post(`/garages`, data);
}

export function getDocs() {
  return api.get(`/garages/api-docs`).then((res) => res.data);
}
